
import React from 'react';

const AboutImageGallery = () => {
  return (
    <>
      <h3 className="text-2xl font-serif font-semibold mb-6 text-center">Galleri</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 my-12">
        <div className="relative rounded-lg overflow-hidden shadow-lg">
          <img 
            src="/lovable-uploads/978ae479-f783-4a9d-8506-9da11ec38295.png" 
            alt="Oscar Gilbert underviser" 
            className="w-full h-64 object-cover"
            width="400" 
            height="300"
            loading="lazy"
          />
        </div>
        <div className="relative rounded-lg overflow-hidden shadow-lg">
          <img 
            src="/lovable-uploads/d8eac62f-f2a4-4db4-a3b1-b173d7c9ff6a.png" 
            alt="Klaverundervisning med Oscar Gilbert" 
            className="w-full h-64 object-cover"
            width="400" 
            height="300"
            loading="lazy"
          />
        </div>
        <div className="relative rounded-lg overflow-hidden shadow-lg">
          <img 
            src="/lovable-uploads/5e10b93f-31e3-44d8-96b2-ff32265f50bd.png" 
            alt="Oscar Gilbert optræder" 
            className="w-full h-64 object-cover"
            width="400" 
            height="300"
            loading="lazy"
          />
        </div>
      </div>
      
      {/* Second row of images */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
        <div className="relative rounded-lg overflow-hidden shadow-lg">
          <img 
            src="/lovable-uploads/ef6b815c-ee7c-43ea-a44b-c7b7e6e914b8.png" 
            alt="Oscar Gilbert underviser" 
            className="w-full h-80 object-cover object-top"
            width="600" 
            height="400"
            loading="lazy"
          />
        </div>
        <div className="relative rounded-lg overflow-hidden shadow-lg">
          <img 
            src="/lovable-uploads/6e7c8d42-0d22-4d7a-994d-ce69e59b7879.png" 
            alt="Oscar Gilbert ved flygelet" 
            className="w-full h-80 object-cover object-top"
            width="600" 
            height="400"
            loading="lazy"
          />
        </div>
      </div>
    </>
  );
};

export default React.memo(AboutImageGallery);
